import React from 'react';
import PropTypes from 'prop-types';
import {Tooltip, Chip} from '@material-ui/core';

function ChipFormatter(props) {
  const {value} = props;

  return (
    <>
      {value.map(
        (
          {
            className = '',
            icon,
            size = 'small',
            text,
            styleColor,
            color = '',
            handleClick,
            tooltip,
          },
          index,
        ) => (
          <Tooltip title={tooltip || text} key={index}>
            <Chip
              className={className}
              icon={icon}
              variant="outlined"
              size={size}
              label={text}
              onClick={handleClick}
              color={color}
            />
          </Tooltip>
        ),
      )}
    </>
  );
}

ChipFormatter.propTypes = {
  value: PropTypes.arrayOf(
    PropTypes.shape({
      tooltip: PropTypes.string,
      icon: PropTypes.element,
      avatar: PropTypes.string,
      text: PropTypes.string.isRequired,
      color: PropTypes.string,
      size: PropTypes.string,
      className: PropTypes.string,
    }),
  ),
};

export default ChipFormatter;
